import { jsx } from "react/jsx-runtime";
import { FormFooter } from "../../../FormFooter.js";
import { LoginPrimaryAction } from "../../../LoginPrimaryAction/index.js";
import { forgotPasswordForm } from "../../forgotPasswordFormSetup.js";
import { useAutoFocusEmptyField } from "../../hooks/useAutoFocusEmptyField.js";
import { useTexts } from "./useTexts.js";
function ForgotPasswordFooter(props) {
  const { buttonProps, autoFocus: autofocusStatus, showUid, footerProps } = props;
  const {
    meta: { submitting }
  } = forgotPasswordForm.useFormMeta();
  const texts = useTexts();
  const autoFocusField = useAutoFocusEmptyField(autofocusStatus, showUid);
  const autoFocus = autoFocusField === "submit";
  return /* @__PURE__ */ jsx(FormFooter, { ...footerProps, children: /* @__PURE__ */ jsx(
    LoginPrimaryAction,
    {
      label: texts.reset,
      testId: "ForgotPasswordBtn",
      disabled: submitting,
      autoFocus,
      componentProps: buttonProps
    }
  ) });
}
export {
  ForgotPasswordFooter
};
//# sourceMappingURL=ForgotPasswordFooter.js.map
